import { AppUpdateHardDialog } from "@/domains/shared/appUpdatePrompt/AppUpdateHardDialog";
import { AppUpdateSoftBanner } from "@/domains/shared/appUpdatePrompt/AppUpdateSoftBanner";
import { installChunkFailHardPath } from "@/domains/shared/appUpdatePrompt/installChunkFailHardPath";
import { useAppUpdateSoftTriggers } from "@/domains/shared/appUpdatePrompt/useAppUpdateSoftTriggers";
import { useEffect } from "react";

/**
 * App-shell host: soft triggers + soft banner + hard dialog for product and /admin/* (BR-12).
 * Landing does not mount this component (BR-12, E-12).
 */
export function AppUpdatePromptHost() {
  useAppUpdateSoftTriggers();

  useEffect(() => {
    // Vite HMR preload errors are not deploy chunk failures (BR-05).
    if (import.meta.env.DEV) {
      return;
    }

    return installChunkFailHardPath();
  }, []);

  return (
    <>
      <AppUpdateSoftBanner />
      <AppUpdateHardDialog />
    </>
  );
}
